import React, { useContext, useEffect, useRef, useState } from 'react';
import Warning from '../Warning';
import { StorefrontContext } from 'providers/storefront';
import styles from './styles';
import FeatureBlock from '../FeatureBlock';
import PostCard from '../PostCard';

const Featured = ({ topicUid, posts, discussion, index }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const { selectedDiscussion, setSelectedDiscussion } =
    useContext(StorefrontContext);
  const blockRef = useRef(null);

  useEffect(() => {
    if (selectedDiscussion?.id === discussion.id) {
      toggleItem(index);
    }
  }, [selectedDiscussion, discussion.id, index]);

  useEffect(() => {
    if (expandedItems[index] && blockRef.current) {
      const yOffset = -80;
      const yPosition =
        blockRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      window.scrollTo({ top: yPosition, behavior: 'smooth' });
    }
  }, [expandedItems, index]);

  const preparePosts = (discussionUid) => {
    const temp = posts.filter((post) =>
      post.data.discussions_group.some(
        (disc) => disc.discussion_link.uid === discussionUid,
      ),
    );
    return temp.sort((a, b) => a.data.title.localeCompare(b.data.title));
  };

  function toggleItem(idx) {
    setExpandedItems((prevState) => ({
      ...prevState,
      [idx]: !prevState[idx],
    }));
  }

  const handleSelectDiscussion = (diss) => {
    setSelectedDiscussion(diss)
  }
// console.log(discussion);

  return (
    <>
      <div className="features-block" key={discussion.id} ref={blockRef}>
        <FeatureBlock
          index={index}
          toggleItem={() => toggleItem(index)}
          expandedItems={expandedItems}
          discussionTitle={discussion.data.discussion_title}
          discussion={discussion}
        />
        <div className={`posts-list ${expandedItems[index] ? 'active' : ''}`}>
          {preparePosts(discussion.uid).length ? (
            preparePosts(discussion.uid).map((post) => (
              <PostCard
                post={post}
                discussionUid={discussion.uid}
                topicUid={topicUid}
                key={post.id}
                discussion={discussion}
                discussionTitle={discussion.data.discussion_title}
                handleSelectDiscussion={handleSelectDiscussion}
              />
            ))
          ) : (
            <Warning message="posts" />
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default Featured;
